import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./header.css";
import Navbar from "./Navbar";
import { apiFetch } from "../config/apiClient";
import { clearAuth, getUser } from "../config/auth";

function AppHeader (){
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
  const checkUser = () => {
    setUser(getUser());
  };

  checkUser();

  // Listen for custom or external changes
  window.addEventListener("storage", checkUser);
  window.addEventListener("userChange", checkUser);

  // Cleanup on unmount
  return () => {
    window.removeEventListener("storage", checkUser);
    window.removeEventListener("userChange", checkUser);
  };
}, []);

  const handleLogout = async () => {
    try {
      await apiFetch("/users/logout", {
        method: "POST",
        auth: true,
        skipUnauthorizedHandler: true,
      });
    } catch {
      // Proceed with local logout even if server logout fails.
    } finally {
      clearAuth();
      setUser(null);
      navigate("/");
    }
  };

  const userRole = String(user?.role || "STUDENT").toUpperCase();
  const dashboardPath = userRole === "ADMIN" ? "/admin/dashboard" : "/dashboard";
    return (
        <>
      <div className="header">
        <div className="logo">AAMSCHOOL</div>
        <div className="top-links">
          <a
            href="https://t.me/aamschool"
            target="_blank"
            rel="noopener noreferrer"
            className="header-telegram-link"
          >
            Join Telegram
          </a>
          {user && (
    <Link to={dashboardPath} className="header-dashboard-link">
      Dashboard
    </Link>
  )}

  {/* When not logged in show Login & Signup links (styled to match site) */}
  {!user ? (
    <>
      <Link to="/login" className="header-auth-link header-login-link">
        Login
      </Link>
      <Link to="/signup" className="header-auth-link header-signup-link">
        Signup
      </Link>
    </>
  ) : (
    <button
      onClick={handleLogout}
      className="header-auth-link header-logout-button"
      type="button"
    >
      Logout
    </button>
  )}
        </div>
      </div>

      <div className="menu">
        <Navbar/>
      </div>
    </>
    );
}
export default AppHeader;
